const aaa = [
	{
		path: "jiyangList",
		component: () => import("@/views/jiyang/jiyang/jiyangList.vue"),
		meta:{title:'寄养管理'},
	},
	{
		path: "jiyangEdit",
		component: () => import("@/views/jiyang/jiyang/jiyangEdit.vue"),
		meta:{title:'寄养管理'},
	},
]
export default aaa;